import { type ComponentProps } from 'react';
import { Toaster as Sonner } from 'sonner';

type ToasterProps = ComponentProps<typeof Sonner>;

/**
 * App-wide toast host.
 *
 * Deliberately thinner than the manager/documents copies of this file: those
 * pull their light/dark mode from `next-themes` (not a dependency here) and
 * style themselves with `bg-success`/`bg-error` tokens this app's Tailwind
 * config doesn't define. `richColors` gets the same success/error treatment
 * from sonner itself.
 *
 * Top-centre because every apply-flow screen pins its CTA to the bottom edge —
 * a bottom toast would land on top of the button it is telling you not to press.
 */
const Toaster = ({ ...props }: ToasterProps) => (
  <Sonner
    position="top-center"
    richColors
    closeButton
    className="toaster group"
    {...props}
  />
);

export { Toaster };
